import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { PolicyEmail } from '@models/PolicyEmail';

@Injectable({
  providedIn: 'root',
})
export class BankAccountService {
  constructor(private http: HttpClient) {}

  getBankAccountByEmail(email) {
    const url = `${environment.backend_server_url_billing}/${email}/bankaccount`;
    return this.http.get(url);
  }

  getBankAccountByEmailWithPolicyNumber(email, policyId) {
    const policyEmail: PolicyEmail = {
      address: email,
      policyNumber: policyId,
    };
    const url = `${environment.backend_server_url_billing}/bankaccount`;
    return this.http.post(url, policyEmail);
  }

  addBankAccount(email, bankAccountDetails, policyId) {
    const policyEmail: PolicyEmail = {
      address: email,
      policyNumber: policyId,
    };
    bankAccountDetails.policyEmail = policyEmail;
    const url = `${environment.backend_server_url_billing}/enroll-bankaccount`;
    return this.http.post(url, bankAccountDetails);
  }

  deleteBankAccount(email, policyId) {
    const policyEmail: PolicyEmail = {
      address: email,
      policyNumber: policyId,
    };
    const url = `${environment.backend_server_url_billing}/unenroll-bankaccount`;
    return this.http.post(url, policyEmail);
  }

  getBankInformation(policyId) {
    const url = `${environment.backend_server_url_billing}/${policyId}/eft-details`;
    return this.http.get(url);
  }
}
